var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.074,
    height: 14.507,
    viewBox: "0 0 11.074 14.507",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7897",
    "data-name": "Path 7897",
    d: "M3534.485,2102.183c-1.237-1.586-2.439-3.073-3.574-4.61a18.486,18.486,0,0,1-1.319-2.234c-1.716-3.182.6-7.019,4.042-7.588a5.522,5.522,0,0,1,6.452,5.29,5.359,5.359,0,0,1-.549,2.221A28.491,28.491,0,0,1,3534.485,2102.183Zm2.89-9a2.823,2.823,0,1,0-2.8,2.838A2.814,2.814,0,0,0,3537.375,2093.187Z",
    transform: "translate(-3529.011 -2087.676)",
    fill: "#3177be"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationService);
export default __webpack_public_path__ + "static/media/location-service.313de269b17484323013d90c246071fc.svg";
export { ForwardRef as ReactComponent };